export const DisclaimerLinkModal: string = 'DisclaimerLinkModal';
